import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TenantSettingsService } from '@app/tenants/services/tenant-settings.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const myProficiencyLevelsLoadedGuard: CanActivateFn = (
	next: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
	const tenantService = inject(TenantSettingsService);

	return tenantService.loadProficiencyLevels().pipe(
		map(data => { return !!data; })
	);
};
